import { render } from "./App.vue?vue&type=template&id=1fdb04de"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1fdb04de&lang=css"

import exportComponent from "C:\\Users\\marti\\tmp\\vue_tutorial\\vue-starter-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__